import { Action } from '@ngrx/store';
import { ErrorEntity, ErrorEntityInterface, ErrorInterface, ErrorStatus } from 'app/core/error-handler/models/index';

import { ErrorActionType } from './error-action-type.model';

export class ErrorRaised implements Action {
  public readonly type: ErrorActionType = ErrorActionType.ErrorRaised;

  constructor(public readonly payload: ErrorEntityInterface) { }
}

export class ErrorRaisedRemoved implements Action {
  public readonly type: ErrorActionType = ErrorActionType.ErrorRaisedRemoved;

  public readonly payload: any = undefined;
}

export function createErrorRaised(error: ErrorInterface): ErrorRaised {
  return new ErrorRaised(new ErrorEntity({
    ...error,
    status: ErrorStatus.Raised,
    timestamp: error.timestamp || Date.now(),
  }));
}
